import { type ExternalToast, toast as sonner } from "sonner";

function errorWithCopy(
	message: string | React.ReactNode,
	data?: ExternalToast,
) {
	return sonner.error(message, {
		action: {
			label: "Copy",
			onClick: () => {
				if (typeof message === "string") {
					navigator.clipboard.writeText(message).catch(() => {});
				}
			},
		},
		...data,
	});
}

export const toast = {
	...sonner,
	error: errorWithCopy,
} as typeof sonner;
